import script from "./Create_Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Create_Edit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__